//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery'

export default {
  components: {
  },
  data () {
    return {
      email: '',
      password: '',
      errmsg: '',
      captchaUrl: '',
      remember: false,
      captcha: ''
    }
  },
  created () {
    this.updateCaptcha()
  },
  mounted () {
    let $this = this;
    $('.js-checkbox').iCheck({
      checkboxClass: 'icheckbox_square-blue',
      radioClass: 'iradio_square-blue',
      increaseArea: '20%' // optional
    })
    .on('ifChecked', function (e) {
      $this.remember = true;
    })
    .on('ifUnchecked', function (e) {
      $this.remember = false;
    });
  },
  computed: {
  },
  methods: {
    updateCaptcha () {
      var timenow = new Date().getTime();
      var url = '/captcha/mews?' + timenow;
      this.captchaUrl = url
      this.captcha = ''
    },
    showError (errmsg) {
      this.errmsg = errmsg
    },
    loginAction () {
      let $this = this;
      let postData = {email: this.email, password: this.password, remember: this.remember, captcha: this.captcha}
      this.$http.post('/api/login', postData)
        .then(resp => {
          if (resp.data.errcode !== 0) {
            $this.showError(resp.data.errmsg)
            $this.updateCaptcha()
            return
          }
          $this.$router.push('home')
        })
        .catch(function (error) {
          console.log(error);
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/PageIndex.vue